<input
  #uploadInput
  class="form-control"
  id="{{ inputId }}"
  type="file"
  accept=".jpg,.jpeg,.png,.bmp,.dib,.gif,.pdf,image/*"
  (change)="onFileSelected($event)"
  [attr.aria-labelledby]="formFileHelpId"
/>
@if (contentControl && validationErrorsEvent) {
  <div validationErrors [for]="contentControl" [errorEmitter]="validationErrorsEvent"></div>
}
@if (showHelpText) {
  <div id="{{ formFileHelpId }}" class="form-text text-dark">{{ helpText }}</div>
}
